import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M4.57 1.25a3.321 3.321 0 0 0-3.32 3.32v6.86a3.322 3.322 0 0 0 3.32 3.32h6.86a3.32 3.32 0 0 0 3.32-3.32.75.75 0 0 0-1.5 0 1.82 1.82 0 0 1-1.82 1.82H4.57a1.83 1.83 0 0 1-1.82-1.82V4.57a1.82 1.82 0 0 1 1.82-1.82h6.86a1.811 1.811 0 0 1 1.82 1.82.75.75 0 0 0 1.5 0 3.32 3.32 0 0 0-3.32-3.32H4.57Z M10 4.408a.7.7 0 0 0-.54.23.751.751 0 0 0 0 1.06l1.7 1.64H5.08a.75.75 0 0 0 0 1.5h6.15l-1.71 1.65a.752.752 0 0 0 .504 1.186.75.75 0 0 0 .496-.106l3-2.94a.754.754 0 0 0 .23-.54.762.762 0 0 0-.23-.54l-3-2.93a.77.77 0 0 0-.52-.21Z';

const draw24px =
  'M7.99 4.25a3.751 3.751 0 0 0-3.71 3.74V16l-.03-.01a3.75 3.75 0 0 0 3.74 3.76h8a3.75 3.75 0 0 0 3.76-3.76.75.75 0 0 0-1.5 0 2.251 2.251 0 0 1-2.26 2.26h-8a2.252 2.252 0 0 1-2.24-2.26v-8a2.25 2.25 0 0 1 2.24-2.24h8a2.25 2.25 0 0 1 2.26 2.24.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.76-3.74h-8Z M14.929 8.38a.75.75 0 0 0-.53 1.28l1.71 1.64H9.03a.75.75 0 0 0 0 1.5h7.1l-1.71 1.67a.751.751 0 0 0 0 1.06.75.75 0 0 0 1.06 0l3.05-2.94a.74.74 0 0 0 .17-.25.68.68 0 0 0 .04-.27c0-.1-.02-.198-.06-.29a.85.85 0 0 0-.17-.25L15.46 8.6a.75.75 0 0 0-.53-.22Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowOutboundIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowOutbound')) as IconWithRender;

ArrowOutboundIcon.displayName = 'ArrowOutboundIcon';
ArrowOutboundIcon.propTypes = Icon.propTypes;
ArrowOutboundIcon.renderIcon = (props) => <ArrowOutboundIcon {...props} />;
export default ArrowOutboundIcon;
